import styled from "styled-components";
import colors from "../../styles/colors";

export const ModalTable = styled.table`
  border: 1px solid ${colors.background.disabled};
  padding: 3px;
  width: 100%;

  th {
    background: ${colors.tableColors.header};
    padding: 5px;
    color: ${colors.tableColors.headerText};
  }
`;

export const ProductNameColumn = styled.td`
  text-align: start;
`;

export const KitProductLine = styled.tr`
  td {
    padding: 5px;
  }
`;
